import { isNull, isUndefined } from "lodash";

import { formatNumber } from "@common/lib/format";
import { isNullOrUndefined } from "@common/lib/misc";

export const formatValue = formatNumber;

// TODO: refactor!
export const getValue = (
  value: string | number | undefined | null,
  min?: number | null,
  max?: number | null,
  fractionalDigits?: number,
  allowEmpty?: string
): string | null => {
  if (isNull(value) || isUndefined(value) || value === "" || isNaN(parseFloat(value.toString()))) return null;

  if (typeof value === "string" && !isNaN(parseFloat(value))) {
    !isNull(min) && !isUndefined(min) && (value = formatValue(Math.max(min, parseFloat(value)), fractionalDigits)!);
    !isNull(max) && !isUndefined(max) && (value = formatValue(Math.min(max, parseFloat(value)), fractionalDigits)!);
  }

  return formatValue(value, fractionalDigits);
};

export const isOffBounds = (value: number, min: number | null | undefined, max: number | null | undefined): boolean =>
  (!isNullOrUndefined(min) && value < min) || (!isNullOrUndefined(max) && value > max);

export const getFinalValue = (
  value: string | number | undefined | null,
  min?: number | null,
  max?: number | null,
  fractionalDigits?: number,
  allowEmpty?: boolean
): number | null => {
  if (!value && !(allowEmpty ?? true)) value = formatValue(min, fractionalDigits);

  const finalValue = getValue(value, min, max, fractionalDigits);

  return isNull(finalValue) ? finalValue : parseFloat(finalValue);
};
